module.exports = __webpack_public_path__ + "static/media/syn-master-red.de81d4b7.svg";